import BottomSheet from "../components/BottomSheet.js";
import SettingsForm, { ValidationError } from "../components/SettingsForm.js";
import { postJSON } from "../helpers.js";

const VerifyDialog = (element, options = {}) => {
  const el = element;
  const opts = {
    ...options,
  };

  let settingsForm;

  const handleVerifyFormSubmit = async (event) => {
    event.preventDefault();
    let formData = checkVerifyForm();
    if (formData) {
      formData.referer = window.location.href;
      const verifyButton = el?.querySelector("#verify-button");
      if (verifyButton) verifyButton.disabled = true;
      const data = await postJSON("/api/verify/", formData);
      if (verifyButton) verifyButton.disabled = false;
      if (data.status == "authenticated") {
        opts.onSuccessfulVerification(data);
      } else {
        opts.onFailedVerification(data);
      }
    }
  };

  const checkVerifyForm = () => {
    const payload = {
      email: settingsForm.form.email.value.trim(),
      temporary_password: settingsForm.validateField(settingsForm.form.verification_number, (field) => {
        if (field.value.match(/^\d{6}$/)) {
          return field.value;
        }
        throw new ValidationError("");
      }),
      temporary_salt: settingsForm.form.verification_salt.value.trim(),
    };
    const verifyButton = el?.querySelector("#verify-button");
    if (payload.temporary_password) {
      if (verifyButton) verifyButton.disabled = false;
      return payload;
    } else {
      if (verifyButton) verifyButton.disabled = true;
      return false;
    }
  };

  const component = BottomSheet(el, {
    componentName: "VerifyDialog",
    closeOnBackdropClick: false,
    onOpen: async (email, temporary_salt) => {
      settingsForm = SettingsForm(el.querySelector("#verify-settings-form"), {
        onSubmit: (event) => handleVerifyFormSubmit(event),
      }).mount();

      settingsForm.on("verification_number", "input blur", () => {
        checkVerifyForm();
      });

      settingsForm.enable();

      /* cleanup */
      settingsForm.setValue("verification_number", "");

      if (el) {
        el.querySelector("#verify_email").innerHTML = email || "";
        el.querySelector("#prepend_verification_salt").innerHTML = temporary_salt || "";
        settingsForm.setValue("verification_salt", temporary_salt || "");
      }

      checkVerifyForm();
    },
    onClose: async () => {
      if (settingsForm) {
        settingsForm.unmount();
      }
    },
  });

  return component;
};

export default VerifyDialog;
